import styled, { keyframes } from "styled-components";

const matrixGreen = "#00FF41";
const matrixDim = "#008F11";
const matrixDark = "#003B00";
const matrixBg = "#000000";

const flicker = keyframes`
  0%   { opacity: 0.97; }
  50%  { opacity: 1; }
  100% { opacity: 0.97; }
`;

export const SContainer = styled.div`
  width: 100%;
  background: ${matrixBg};
  color: ${matrixGreen};
  font-family: "Courier New", Consolas, "Liberation Mono", Menlo, monospace;
  font-size: 12px;
  padding: 8px 12px;
  border-bottom: 1px solid ${matrixDim};
  text-shadow: 0 0 4px ${matrixGreen};
  animation: ${flicker} 3s infinite;
  user-select: none;
`;

export const SHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px dashed ${matrixDim};
  padding-bottom: 4px;
  margin-bottom: 6px;
  letter-spacing: 1px;
`;

export const STitle = styled.span`
  font-weight: bold;
  &::before {
    content: "▣ ";
  }
`;

export const SMeta = styled.span`
  font-size: 11px;
  color: ${matrixDim};
`;

export const SButtonsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
`;

export const SButton = styled.button<{ $variant?: "danger" | "neutral" }>`
  background: ${matrixBg};
  color: ${({ $variant }) => ($variant === "danger" ? "#FF5555" : matrixGreen)};
  border: 1px solid
    ${({ $variant }) => ($variant === "danger" ? "#FF5555" : matrixDim)};
  padding: 4px 10px;
  font-family: inherit;
  font-size: 12px;
  cursor: pointer;
  text-shadow: 0 0 4px currentColor;
  transition: background 0.1s ease;
  letter-spacing: 0.5px;

  &:hover:not(:disabled) {
    background: ${({ $variant }) =>
      $variant === "danger" ? "#1a0000" : matrixDark};
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  &::before {
    content: "> ";
    color: ${matrixDim};
  }
`;

export const SLog = styled.div`
  background: #050505;
  border: 1px solid ${matrixDark};
  padding: 4px 8px;
  max-height: 120px;
  overflow-y: auto;
  font-size: 11px;

  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${matrixDim};
  }
  &::-webkit-scrollbar-track {
    background: ${matrixBg};
  }
`;

export const SLogLine = styled.div<{ $kind?: "ok" | "err" | "info" }>`
  color: ${({ $kind }) => {
    if ($kind === "err") return "#FF5555";
    if ($kind === "info") return matrixDim;
    return matrixGreen;
  }};
  white-space: pre-wrap;
  word-break: break-all;
`;
